enum SessionCodes {
  EBADCSRFTOKEN = "EBADCSRFTOKEN"
}

export default SessionCodes
